import Dash from "../../../../../../packages/design-system/src/Dash";
import Text from "../../../../../../packages/design-system/src/Text";
import * as React from 'react';
export default {
  Dash,
  Text,
  React
};